"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "castelletto-merli": {
    "51d91cb4": [{
      "hkey": "60d0dd02",
      "slug": "castelletto-merli",
      "name": "Castelletto Merli",
      "primary": true,
      "skipSearch": false
    }],
    "costamezzana": [{
      "hkey": "60d0dd02",
      "slug": "castelletto-merli",
      "name": "Castelletto Merli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3a7a9467": [{
      "hkey": "b946e5a3",
      "slug": "terfangato",
      "name": "Terfangato",
      "primary": true,
      "skipSearch": false
    }],
    "terfengato": [{
      "hkey": "b946e5a3",
      "slug": "terfangato",
      "name": "Terfangato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "37595d83": [{
      "hkey": "60d0dd02",
      "slug": "castelletto-merli",
      "name": "Castelletto Merli",
      "primary": true,
      "skipSearch": false
    }],
    "terfengo": [{
      "hkey": "60d0dd02",
      "slug": "castelletto-merli",
      "name": "Castelletto Merli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7c8512e2": [{
      "hkey": "60d0dd02",
      "slug": "castelletto-merli",
      "name": "Castelletto Merli",
      "primary": true,
      "skipSearch": false
    }],
    "valle": [{
      "hkey": "60d0dd02",
      "slug": "castelletto-merli",
      "name": "Castelletto Merli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;